var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data.item.codigoColor != null )?_c('b-icon',{style:({color: _vm.data.item.codigoColor}),attrs:{"icon":"circle-fill","aria-hidden":"true","font-scale":"1.5"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }